import { Trans, useTranslation } from 'react-i18next';
import entryScreenKsaAr from '@/assets/images/entry-screen-ksa-ar.png';
import entryScreenKsaEn from '@/assets/images/entry-screen-ksa-en.png';
import entryScreenUaeAr from '@/assets/images/entry-screen-uae-ar.png';
import entryScreenUaeEn from '@/assets/images/entry-screen-uae-en.png';
import { CurvedTextWithStars } from '@/components/CurvedTextWithStars/CurvedTextWithStars';
import { useOutletKitchen } from '@/components/LinkToMenu/useOutletKitchen';
import { useCurrency } from '@/context/CurrencyContext/CurrencyContext';
import { useGetCashbackPercentageValue } from '@/hooks/useGetCashbackPercentageValue';
import { useGetSignUpBonusMinimumSpendValue } from '@/hooks/useGetSignUpBonusMinimumSpendValue';
import { useGetSignUpBonusValue } from '@/hooks/useGetSignUpBonusValue';
import { useLanguage } from '@/hooks/useLanguage';
import useValidateQueryParams from '@/hooks/useValidateQueryParams';
import styles from './AcquisitionJourneyEnabledContent.module.scss';

const entryScreens = {
  SA: { en: entryScreenKsaEn, ar: entryScreenKsaAr },
  AE: { en: entryScreenUaeEn, ar: entryScreenUaeAr },
} as const;

export const AcquisitionJourneyEnabledContent = () => {
  const { t } = useTranslation();
  const bonusValue = useGetSignUpBonusValue();
  const bonusMinimumSpendValue = useGetSignUpBonusMinimumSpendValue();
  const cashbackPercentageValue = useGetCashbackPercentageValue();
  const { currencySymbol } = useCurrency();
  const { queryParams } = useValidateQueryParams();
  const { outletId } = queryParams();
  const { country } = useOutletKitchen(outletId);

  const { language } = useLanguage();
  const hasBonus = bonusValue > 0;

  if (!hasBonus) {
    const screens = country === 'SA' ? entryScreens.SA : entryScreens.AE;
    return (
      <img
        src={language === 'ar' ? screens.ar : screens.en}
        className={styles.entryScreen}
        alt=""
      />
    );
  }

  return (
    <>
      <div className={styles.tooltips}>
        {hasBonus && (
          <>
            <CurvedTextWithStars
              className={styles.signUpBonus}
              textLines={[
                {
                  text: t('menu.entry.signUpBonus.firstLine'),
                  fontSize: 80,
                },
                {
                  text: t('menu.entry.signUpBonus.secondLine'),
                  fontSize: 100,
                },
              ]}
            />
          </>
        )}
        <div
          className={`${styles.purpleTooltip} ${hasBonus && styles.purpleTooltipWithSignUpBonus}`}
        >
          <Trans
            key={String(hasBonus)}
            i18nKey={`menu.entry.${hasBonus ? 'bonusTooltipWithBonus' : 'bonusTooltipWithoutBonus'}`}
            t={t}
            values={{
              bonusValue,
              currency: currencySymbol,
              cashbackPercentageValue,
            }}
            components={{
              br: <br />,
            }}
          />
        </div>
      </div>

      <p className={styles.promoDescription}>
        {bonusMinimumSpendValue > 0 && (
          <>
            {t('menu.entry.promoWithMinimumSpend', {
              minimumSpend: bonusMinimumSpendValue,
              currency: currencySymbol,
            })}
            <br />
          </>
        )}
        {t('menu.entry.termsConditionsApply')}
      </p>
    </>
  );
};
